import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateExpenseRateSheetMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateExpenseRateSheetMutation = { __typename?: 'MutationModel', expenseRates?: { __typename?: 'ExpenseRatesMutationModel', createRateSheet?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const CreateExpenseRateSheetDocument = gql`
    mutation CreateExpenseRateSheet($name: String!) {
  expenseRates {
    createRateSheet(name: $name) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CreateExpenseRateSheetMutationFn = Apollo.MutationFunction<CreateExpenseRateSheetMutation, CreateExpenseRateSheetMutationVariables>;

/**
 * __useCreateExpenseRateSheetMutation__
 *
 * To run a mutation, you first call `useCreateExpenseRateSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseRateSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseRateSheetMutation, { data, loading, error }] = useCreateExpenseRateSheetMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateExpenseRateSheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseRateSheetMutation, CreateExpenseRateSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpenseRateSheetMutation, CreateExpenseRateSheetMutationVariables>(CreateExpenseRateSheetDocument, options);
      }
export type CreateExpenseRateSheetMutationHookResult = ReturnType<typeof useCreateExpenseRateSheetMutation>;
export type CreateExpenseRateSheetMutationResult = Apollo.MutationResult<CreateExpenseRateSheetMutation>;
export type CreateExpenseRateSheetMutationOptions = Apollo.BaseMutationOptions<CreateExpenseRateSheetMutation, CreateExpenseRateSheetMutationVariables>;